module.exports = __webpack_public_path__ + "img/mail-ic-popup.eb0c29aa.svg";